import React from "react";
import DesignItemHeader from "./DesignItemHeader";
import DesignItemLoading from "./DesignItemLoading";
import { WHITE_005 } from "../../constants/AppColors";
import uiPrefix from "../../utils/UiPrefixUtils";

const DesignItemList = ({ label, active, loading, level, children }) => {
  let header = null;
  if (label) {
    header = <DesignItemHeader heading={label} />;
  }

  let content = null;
  if (loading) {
    content = <DesignItemLoading />;
  } else {
    content = children;
  }
  let listPadding = 0;
  if (level > 0) {
    listPadding = 20 + level * 3;
  }
  const listStyle = {
    paddingLeft: listPadding,
  };

  if (active) {
    listStyle.paddingTop = 8;
    listStyle.paddingBottom = 16;
    listStyle.backgroundColor = "var(--background-base-primary)";
    listStyle.borderBottom = `1px solid ${WHITE_005}`;
  }

  return (
    <div className={uiPrefix("design-item-list")} style={listStyle}>
      {header}
      <div>{content}</div>
    </div>
  );
};

DesignItemList.defaultProps = {
  label: null,
  active: false,
  loading: false,
  level: 0,
};

export default DesignItemList;
